import { OwnerUserService } from '../../../../../../services/owner-user.service';
import {
    Component,
    OnInit,
    ViewEncapsulation,
    ElementRef
} from '@angular/core';
import { Router } from '@angular/router';
import { DatatableComponent } from '../../../datatable.component';

@Component({
    selector: 'app-users',
    templateUrl: './list-user.component.html',
    encapsulation: ViewEncapsulation.None
})
export class ListUserComponent extends DatatableComponent implements OnInit {
    updateTrigger() {
        this.router.navigate(['/owner/users/update/' + this.id]);
    }
    deleteTrigger() {
        this.deleteRow(this.id);
    }
    buildDatatableParams() {
        this.columns = [
            {
                field: 'id',
                title: '#',
                sortable: false, // disable sort for this column
                width: 20,
                selector: { class: 'm-checkbox--solid m-checkbox--brand' }
            },
            {
                field: 'firstName',
                title: 'First Name',
                template: function(row) {
                    // callback function support for column rendering
                    return row.firstName;
                }
            },
            {
                field: 'lastName',
                title: 'Last Name',
                template: function(row) {
                    // callback function support for column rendering
                    return row.lastName;
                }
            },
            {
                field: 'email',
                title: 'Email',
                template: function(row) {
                    // callback function support for column rendering
                    return row.email;
                }
            },
            {
                field: 'Actions',
                width: 80,
                title: 'Actions',
                sortable: false,
                overflow: 'visible',
                textAlign: 'center',
                template: function(row) {
                    return (
                        '\
                    <button data-id="' +
                        row.id +
                        '" id="updateUser' +
                        row.id +
                        '" class="update-row m-datatable--on-layout-updated m-portlet__nav-link btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill" title="Edit "><i class="la la-edit"></i></button>\
                    <button data-id="' +
                        row.id +
                        '" id="deleteUser' +
                        row.id +
                        '" (click)="deleteUser( ' +
                        row.email +
                        ')" class="delete-row m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill" title="Delete "><i class="la la-trash"></i></button>\
                '
                    );
                }
            }
        ];
    }

    constructor(
        private userService: OwnerUserService,
        protected el: ElementRef,
        private router: Router
    ) {
        super(el);
        this.datatableUrl = '/ownerusers/list';
    }

    getSelectedRows() {
        var ids = this.datatable
            .rows('.m-datatable__row--active')
            .nodes()
            .find('.m-checkbox--single > [type="checkbox"]')
            .map(function(chk) {
                return $(chk).val();
            });
        return ids;
    }

    deleteRow(id: string) {
        this.swalService.confirmDelete().then(res => {
            if (res.value) {
                this.userService.delete(id).subscribe(() => {
                    this.datatable.load();
                    this.swalService.successDelete();
                });
            }
        });
    }

    ngOnInit() {
        this.buildDatatable();
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/owner/owner-user/list-user/list-user.component.ts